import {
  CLEAR_MOVE_MODAL_FOLDERS,
  MOVE_MODAL_CREATE_NEW_FOLDER_HIDE,
  MOVE_MODAL_CREATE_NEW_FOLDER_SHOW,
  MOVE_MODAL_CREATE_NEW_FOLDER_SUCCESS,
  MOVE_MODAL_UPDATE_FOLDER_TO_MOVE_TO,
  MOVE_MODAL_UPDATE_NEW_FOLDER_NAME,
  TOGGLE_MOVE_MODAL,
  UPDATE_FETCHING_MOVE_MODAL_TOP_LEVEL_FOLDER,
  UPDATE_MOVE_MODAL_FOLDERS,
  UPDATE_MOVE_MODAL_TOP_LEVEL_FOLDER,
} from 'constants/actions';

export const clearMoveModalFolders = () => {
  return { type: CLEAR_MOVE_MODAL_FOLDERS };
};

export const updateMoveModalFolders = folders => {
  return { type: UPDATE_MOVE_MODAL_FOLDERS, folders };
};

export const updateMoveModalTopLevelFolder = folder => {
  return { type: UPDATE_MOVE_MODAL_TOP_LEVEL_FOLDER, folder };
};

export const updateFetchingMoveModalTopLevelFolder = isFetching => {
  return { type: UPDATE_FETCHING_MOVE_MODAL_TOP_LEVEL_FOLDER, isFetching };
};

export const createNewFolderShow = () => {
  return { type: MOVE_MODAL_CREATE_NEW_FOLDER_SHOW };
};

export const createNewFolderUpdateName = name => {
  return { type: MOVE_MODAL_UPDATE_NEW_FOLDER_NAME, name };
};

export const createNewFolderHide = () => {
  return { type: MOVE_MODAL_CREATE_NEW_FOLDER_HIDE };
};

export const updateFolderToMoveTo = folder => {
  return {
    type: MOVE_MODAL_UPDATE_FOLDER_TO_MOVE_TO,
    folder,
  };
};

export const updateShowMoveModal = (show, items = null) => {
  return {
    type: TOGGLE_MOVE_MODAL,
    show,
    items,
  };
};

export const createNewFolderSuccess = folder => {
  return {
    type: MOVE_MODAL_CREATE_NEW_FOLDER_SUCCESS,
    folder,
  };
};
